export function addDays<T extends Date | undefined>(date: T, days: number): T {
  if (!date) {
    return undefined as T;
  }

  const result = new Date(date);
  result.setDate(result.getDate() + days);
  return result as T;
}

export function getLaterDate(first?: Date, second?: Date): Date | undefined {
  if (!first) {
    return second;
  }
  if (!second) {
    return first;
  }
  return first.getTime() >= second.getTime() ? first : second;
}

export function getEarlierDate(first?: Date, second?: Date): Date | undefined {
  if (!first) {
    return second;
  }
  if (!second) {
    return first;
  }
  return first.getTime() <= second.getTime() ? first : second;
}

/** Compares two optional dates for sorting. `undefined` sorts before defined dates (represents "since forever"). */
export function dateValueComparer(valueA?: Date, valueB?: Date): number {
  if (!valueA && !valueB) {
    return 0;
  }
  if (!valueA) {
    return -1;
  }
  if (!valueB) {
    return 1;
  }

  return valueA.getTime() - valueB.getTime();
}

export function isSameDate(date1?: Date, date2?: Date): boolean {
  if (!date1 || !date2) {
    return false;
  }
  const d1 = new Date(date1);
  const d2 = new Date(date2);
  return (
    d1.getFullYear() === d2.getFullYear() &&
    d1.getMonth() === d2.getMonth() &&
    d1.getDate() === d2.getDate()
  );
}
